import { render, staticRenderFns } from "./coalsearchzlwh.vue?vue&type=template&id=2656a79c&scoped=true"
import script from "./coalsearchzlwh.vue?vue&type=script&lang=js"
export * from "./coalsearchzlwh.vue?vue&type=script&lang=js"
import style0 from "./coalsearchzlwh.vue?vue&type=style&index=0&id=2656a79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2656a79c",
  null
  
)

export default component.exports